import { AddressFormData } from 'src/app/_widgets/address-form/address-form-data';
import { IFactory, PGEndpointPath } from './i-factory';
import { BEImpresa, Impresa } from './impresa';

export class ImpresaFactory implements IFactory<BEImpresa, Impresa> {
  toView(res: BEImpresa): Impresa {
    return {
      ...res,
      dataCostituzione:
        res.dataCostituzione != undefined
          ? new Date(res.dataCostituzione)
          : undefined,
      dataInizioAttivita:
        res.dataInizioAttivita != undefined
          ? new Date(res.dataInizioAttivita)
          : undefined,
      dataRilevazioneInps:
        res.dataRilevazioneInps != undefined
          ? new Date(res.dataRilevazioneInps)
          : undefined,
      location: {
        street_number: res.civicoSedeLegale,
        route: res.indirizzoSedeLegale,
        postal_code: res.capSedeLegale,
        administrative_area_level_2: res.provinciaSedeLegale,
        administrative_area_level_3: res.comuneSedeLegale,
      },
    };
  }

  toDomain(
    updatedData: Partial<Impresa>,
    tipoContabilita?: Impresa['tipoContabilita'],
    kycData?: Impresa['kic'] | undefined,
    location?: Partial<AddressFormData>
  ) {
    let body: Partial<Impresa> = {
      ...updatedData,
      kic: kycData,
    };

    body.documentazioneNumeroDipendenti = undefined;

    if (location) {
      body.capSedeLegale = location.postal_code;
      body.civicoSedeLegale = location.street_number;
      body.indirizzoSedeLegale = location.route;
      body.provinciaSedeLegale = location.administrative_area_level_2;
      body.comuneSedeLegale = location.administrative_area_level_3;
      body.paeseSedeLegale = location.country;
    }

    if (tipoContabilita) {
      body.tipoContabilita = tipoContabilita;
    }
    if (kycData) {
      body.kic = kycData;
    }

    return body;
  }

  endpointPath: PGEndpointPath = 'persona-giuridica';
}
